import React, {useState} from "react";
import { useDispatch } from "react-redux";
import moment from "moment";

import Header from "../../components/Header";
import Input from "../../components/Input";
import Conversations from "../../components/Conversations";
import Chat from "../../components/Chat";
import Select from "../../components/Select";

import { Container, FormSideContainer } from "./styles";

//Action Functions
import { removeChatIdFromTheList } from "../../redux/actions/chatsWithNewMessages"

//Assets
import search from "../../assets/icons/search.svg";

//Interface
import { MessagesForSmallInterface } from "./interfaces"

const Messages = (props: MessagesForSmallInterface) => {
    const [ isConversationsPage, setIsConversationsPage ] = useState(true);
    const [selectedConversation, setSelectedConversation] = useState({
        id: ""
    });

    const dispatch = useDispatch();

    const handleClick = (conversation: any) => {
        setSelectedConversation(conversation);
        setIsConversationsPage(false);
        dispatch(removeChatIdFromTheList(conversation.id));
    }

    const generateConversations = () => {
        return props.conversations.map(conversation => {
            // console.log(conversation.id, chatWithNewMessageIdList.list.includes(conversation.id)) 
            return (
                <div key={conversation.id} onClick={() => handleClick(conversation)}> 
                    <Conversations 
                        id={conversation.id} 
                        topic={conversation.title}
                        author="Colégio Moreira"
                        moment={moment(conversation.created_at).format("hh:mm")}
                        status="Encerrado"
                    />
                </div>
            )
        })
    }

    const conversationsPage = () => {
        return(
            <div>
                <Header title="Mensagens" subTitle="Área de mensagens enviadas pelos clientes" subTitleWidth={182}/>

                <div className="inputWithIcon w-100 mb-3">
                    <Input placeholder="Cliente/Protocolo"/>
                    <img src={search} style={{top: "0.10rem"}}/>        
                </div>

                <Select>
                    <option>Todas as mensagens</option>
                </Select>
                
                {generateConversations()}

            </div>
        )
    }

    const chatPage = () => {
        return(
            <Chat 
                backToConversations={setIsConversationsPage} 
                chatData={selectedConversation}
            />
        )
    }

    return(
        <Container>
            {isConversationsPage ? conversationsPage() : chatPage()}
        </Container>
    )
}

export default Messages;